import { ServiceBaseProto } from '#websocket/client/proto';
import { KEY_RANGE_LOCKING_RESPONSE_TYPE } from './types';
export class LockResponse {
    result;
    constructor(response) {
        const responseMsgObject = ServiceBaseProto.ResponseMsg.toObject(response);
        this.result = responseMsgObject[KEY_RANGE_LOCKING_RESPONSE_TYPE]
            .lockResponse;
    }
}
